var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcn24X24SelectedReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 1.5C9.1017 1.5 8.15285 2.38331 8.02539 3.5H6.25C5.01 3.5 4 4.51 4 5.75V19.25C4 20.49 5.01 21.5 6.25 21.5H17.75C18.99 21.5 20 20.49 20 19.25V5.75C20 4.51 18.99 3.5 17.75 3.5H15.9746C15.8471 2.38331 14.8983 1.5 13.75 1.5H10.25ZM10.25 3H13.75C14.1732 3 14.5 3.32675 14.5 3.75C14.5 4.17325 14.1732 4.5 13.75 4.5H10.25C9.82675 4.5 9.5 4.17325 9.5 3.75C9.5 3.32675 9.82675 3 10.25 3ZM8.25 7.5H15.75C16.164 7.5 16.5 7.8355 16.5 8.25C16.5 8.6645 16.164 9 15.75 9H8.25C7.836 9 7.5 8.6645 7.5 8.25C7.5 7.8355 7.836 7.5 8.25 7.5ZM8.25 10.5H12.25C12.664 10.5 13 10.8355 13 11.25C13 11.6645 12.664 12 12.25 12H8.25C7.836 12 7.5 11.6645 7.5 11.25C7.5 10.8355 7.836 10.5 8.25 10.5ZM16.251 13.5C16.4429 13.5 16.6347 13.5732 16.7812 13.7197C17.0743 14.0122 17.0743 14.4878 16.7812 14.7803L13.2812 18.2803C13.0112 18.5508 12.5807 18.5749 12.2822 18.3359L10.251 16.7109L8.21875 18.3359C8.07975 18.4469 7.91498 18.5 7.75098 18.5C7.53098 18.5 7.31204 18.4038 7.16504 18.2178C6.90604 17.8943 6.95923 17.4231 7.28223 17.1641L9.78223 15.1641C10.0567 14.9451 10.4452 14.9451 10.7197 15.1641L12.6953 16.7451L15.7207 13.7197C15.8672 13.5732 16.0591 13.5 16.251 13.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn24X24SelectedReport);
export default __webpack_public_path__ + "static/media/icn_24x24_selected_report.ad458d4aa22bd621e181410c3cba6278.svg";
export { ForwardRef as ReactComponent };